<div *ngIf="form"
     class="responses__list"
     style="padding: 10px 10px 10px 10px;">
  <mat-card  class="mat-elevation-z2">
    <mat-card-content fxLayoutGap="10px">
      <div style="padding-bottom: 5px;">
        <div fxLayout="row" fxLayoutGap="5px" fxFlex="100">
          <div fxFlex="50">
            <app-filter-fields-response-selection *ngIf="form"
                                                  [form]="form"
                                                  [backFilterStates]="backFilterStates"
                                                  (onFiltering)="filteringResponsesFields($event)">
            </app-filter-fields-response-selection>
          </div>
          <div fxFlex="50">
            <app-filter-selection *ngIf="form"
                                [form]="form"
                                (onFiltering)="filteringCustomsFields($event)"></app-filter-selection>
          </div>
          <div fxFlexAlign="end">
            <mat-progress-bar *ngIf="exporting" [mode]="'indeterminate'"></mat-progress-bar>
            <button fxFlexAlign="end"
                    mat-raised-button
                    [disabled]="exporting"
                    (click)="exportExcel()"
                    matTooltip="Export Excel des demandes"
                    style="cursor: pointer;">
              <i class="fa fa-file-excel-o fa-2x" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
      <div>
        <app-data-table *ngIf="urlListValidate"
          [urlBaseOverride]="urlListValidate"
          [actions]="actions"
          [columns]="columns"
          [dataSource]="dsResponses"
          [extraParams]="extraParams"
          [extraDict]="extraDict"
          [filterDisplay]="true"
          [flexAction]="5"
          [flexColumn]="90"
          [fontSizeCell]="'0.9em'"
          [minFilter]="1" [pageSize]="10"
          [pageSizesList]="[5,10,25]"
          [placeHolderFilter]="'Rechercher de réponses sur une référence ou un demandeur (nom/prénom)'"
          [refreshButton]="true"
          [refreshIcone]="false"
          [showFirstLastButtons]="true"
          [showLoader]="true"
          [toolTipFilter]="'Rechercher de réponses sur une référence ou un demandeur (nom/prénom)'">
        </app-data-table>
      </div>
    </mat-card-content>
  </mat-card>
</div>
